<form class="event-form-wrap event-form create-place" (keydown.enter)="$event.preventDefault()">
    <div class="create-place-header">
        <div headerTitle>Add Place Manually</div>
        <span (click)="goBack()"><mat-icon>chevron_left</mat-icon>Back to places</span>
    </div>
    <ig-row>
        <ig-col [xs]="12" [md]="8" [lg]="8" class="create-event-fields">
            <ig-row>
                <ig-col [xs]="12">
                    <ig-field label="Name" [(ngModel)]="command.name" [isRequired]="true"
                        [formControl]="createPlaceForm.get('name')">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-address-input label="Location (type and pick from the dropdown)"
                        matTooltip="please type and select an address from the dropdown" [isRequired]="true"
                        [(ngModel)]="command.address" [formControl]="createPlaceForm.get('address')">
                    </ig-address-input>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <div (click)="showEditCategoryModal()" class="edit-category-btn"
                        [class.disabled]="toggles&&!toggles.placeCalendar">Edit Category</div>
                    <ig-field label="Category" [(ngModel)]="categoryText" [isRequired]="true" [disabled]="true"
                        [matTooltip]="categoryText" [formControl]="createPlaceForm.get('category')">
                    </ig-field>
                </ig-col>
            </ig-row>

            <ig-row>
                <ig-col [xs]="12" class="relative">
                    <mat-checkbox class="m-b-3" name="GDPREmail" [(ngModel)]="isEmailGDPRAllowed"
                        style="position: absolute;top: 18px;z-index: 2"></mat-checkbox>
                    <ig-field label="Place Owner Email Address"
                        label2="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I understand and agree that this email will only be used for admin purposes, in case we need to contact you about your event. It will not be displayed publicly in your event listing. No additional user data is tracked or stored. We pride ourselves on having a 100% GDPR-compliant SaaS and our content distribution services are built with privacy in mind from the bottom and up."
                        [isRequired]="false" [disabled]="!isEmailGDPRAllowed" icon="mail"
                        [formControl]="createPlaceForm.get('ownerEmail')" [(ngModel)]="command.ownerEmail">
                    </ig-field>
                </ig-col>
            </ig-row>

            <ig-row>
                <ig-col [xs]="12">
                    <ig-field label="Web Site" [(ngModel)]="command.website"
                        [formControl]="createPlaceForm.get('website')">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <!--<ig-mat-field label="Description"-->
                    <!--[(ngModel)]="command.description"-->
                    <!--[formControl]="createPlaceForm.get('description')">-->
                    <!--</ig-mat-field>-->
                    <mat-form-field class="text-area">
                        <textarea #description matInput placeholder="Description" type="textArea"
                            [(ngModel)]="command.description" (input)="descriptionChange()"
                            [formControl]="createPlaceForm.get('description')">
                        </textarea>
                    </mat-form-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-image-selector [command]="command" label="Upload Place Image" [label2]="imageUploaderLabel2"
                        (onImageChanged)="onImageChange($event)" [selectedImageData]="selectedImageData">
                    </ig-image-selector>
                    <mat-checkbox *ngIf="isImageChanged" (change)="hasCopyrights=!hasCopyrights" class="m-t-1">By
                        updating this image, you agree this media is royalty-free or that your organization has the
                        right to use and promote this image on your website.
                    </mat-checkbox>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-success-wrap #createPlaceSuccess [delay]="100"
                        text="Your place has been submitted successfully!">
                        <ig-button [isAsync]="true" class="m-t-2"
                            [disabled]="createPlaceForm.invalid||(isImageChanged && !hasCopyrights)" color="accent"
                            size="md" [style.max-width]="isMobile?'unset':'200px'" (trigger)="createPlace($event)">
                            Submit your place
                        </ig-button>
                    </ig-success-wrap>
                </ig-col>
            </ig-row>
        </ig-col>
    </ig-row>

</form>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/create.place/create.place.component.html